export default __webpack_public_path__ + "static/media/asoulforourfeast4.206ad047.png";